import React from 'react'
import { useInView } from 'react-intersection-observer';
import './portfolio.css'
// import IMG2 from '../../assets/portfolio2.png'
import IMG3 from '../../assets/portfolio3.png'

// DO NOT USE THE IMAGES IN PRODUCTION

const data = [
  {
    id: 1,
    image: 'https://user-images.githubusercontent.com/36836868/143786280-e6f8769a-1988-4818-9bb6-38119c1e5ce3.png',
    title: 'ImgToAscii',
    github: 'https://github.com/ehlwas/ImgToAscii',
    demo: 'blank',
    isGithub: 1,
    isDemo: 0
  },
  // {
  //   id: 2,
  //   image: IMG2,
  //   title: 'Job Listing Website (AplikantePH)',
  //   github: 'https://github.com',
  //   demo: 'aplikante.ph',
  //   isGithub: 0,
  //   isDemo: 1
  // },
  {
    id: 2,
    image: IMG3,
    title: 'A WEB-BASED COMPUTER QUOTATION RECOMMENDER (Build-O-PC)',
    github: 'blank',
    demo: 'http://buildopc.great-site.net',
    isGithub: 0,
    isDemo: 1
  }
]

const Portfolio = () => {
  const { ref: experienceRef, inView: myElementIsVisible } = useInView();

  let titleStyle = !myElementIsVisible ? 'fade-out' : 'fade-in'

  let customStyle = 'portfolio__item '
  customStyle += !myElementIsVisible ? ' item-hide' : 'fade-in'
  

  return (
    <section id='portfolio' ref={experienceRef}>
      <h5 className={titleStyle}>My Recent Work</h5>
      <h2 className={titleStyle}>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github, demo, isGithub, isDemo}) => {
            return (
              <article key={id} className={customStyle}>
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                {isGithub === 1 && <a href={github} className='btn btn-primary' target='_blank' rel="noreferrer">Github</a>}
                {isDemo === 1 && <a href={demo} className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>}
              </div>
            </article>
            )
          })
        }
      </div>
    </section>
  )
}

export default Portfolio